import type { ReactNode } from 'react'
import styles from './DashboardSection.module.css'

type DashboardSectionProps = {
  title: string
  isOpen: boolean
  onToggle: () => void
  contentId: string
  children: ReactNode
  contentClassName?: string
  headerActions?: ReactNode
}

export function DashboardSection({
  title,
  isOpen,
  onToggle,
  contentId,
  children,
  contentClassName,
  headerActions,
}: DashboardSectionProps) {
  const contentClasses = contentClassName
    ? `${styles.content} ${contentClassName}`
    : styles.content

  return (
    <section className={styles.card}>
      <div className={styles.header}>
        <button
          type="button"
          className={styles.toggle}
          aria-expanded={isOpen}
          aria-controls={contentId}
          onClick={onToggle}
        >
          <span className={styles.icon} aria-hidden="true">
            {isOpen ? '▼' : '▶'}
          </span>
          <span className={styles.label}>{title}</span>
        </button>

        {headerActions ? <div className={styles.actions}>{headerActions}</div> : null}
      </div>

      {isOpen ? (
        <div id={contentId} className={contentClasses}>
          {children}
        </div>
      ) : null}
    </section>
  )
}
